import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, CheckBox, Input, Icon, Card, Tooltip } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View, TouchableOpacity, BackHandler } from 'react-native';
import {CustomerInfo} from './topBar.js'
import Sign from './sign.js'
import {useSelector, useDispatch} from 'react-redux';
import moment from 'jalali-moment'
import * as ImagePicker from 'expo-image-picker';
import trackerApi from '../../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../../root.navigation.js';
import { useFocusEffect } from '@react-navigation/native';
import { setInvoice } from '../../../../store/actions/request'
import Modal from 'modal-react-native-web';

import AsyncStorage from '@react-native-async-storage/async-storage';
const PlusIcon = (props) => (
  <Icon {...props}  name='plus'/>
);
const CameraIcon = (props) => (
  <Icon {...props}  name='camera'/>
);
const GalleryIcon = (props) => (
  <Icon {...props}  name='image-2'/>
);

const LinkIcon = (props) => (
  <Icon {...props}  name='external-link-outline'/>
);

const  width= Dimensions.get('window').width-40
export const CompleteScreen = ({ navigation }) => {
  const data = useSelector( state => state.request.data);
  const registerInvoice = useSelector( state => state.request.invoice);

  const [payment, setPayment] = useState(0)
  const [modal, setModal] = useState(false)
  const [receiverChecked, setReceiverChecked] = useState(false);
  const [customerChecked, setCustomerChecked] = useState(true);
  const [btnDisable, setBtnDisable] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [checked10, setChecked10] = useState(false);
  const [cost1, setCost1] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [costs, setCosts] = useState([])
  const [newUri, setNewUri] = useState(null);
  const [oldUri, setOldUri] = useState(null);
  const [signUri, setSignUri] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0)
  const [signatureModal, setSignatureModal] = useState(false)
  const [visible, setVisible] = React.useState(false);

const dispatch = useDispatch()
  const getData = async(start)=>{
    const token =  await AsyncStorage.getItem('userId');
    const response0 = await trackerApi.post('/invoice/status', {request_id: data.id}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response0.data.status){
    if(response0.data.results) {
      dispatch(setInvoice(response0.data.results))
    }
  }
    const response = await trackerApi.post('/invoice/invoice_details',
      {
        request: data.id,
      } ,
      {
        headers: {Authorization: `Bearer ${token}`}
      });
      console.log(response.data.cost);
      if(response.data.status) {
        setCosts(response.data.cost)
        response.data.cost.map((data)=>{
          start += Number(data.service_cost) * Number(data.qty)
        })
        setTotalPrice(start)
      }
      else showMessage({
          message: `خطای دیتابیس`,
          type: "danger",
        });
    }
  useEffect(() => {
    (async () => {
        if (Platform.OS !== 'web') {
          const { status1 } = await ImagePicker.requestMediaLibraryPermissionsAsync();
          const { status2 } = await ImagePicker.requestCameraPermissionsAsync();
          if (status1 !== 'granted') {
            console.log('Sorry, we need camera roll permissions to make this work!');
          }
        }

      })();
      getData(0)

  }, [newUri]);

  useFocusEffect(
    React.useCallback(() => {
      const onBackPress = () => {
        console.log('back pressed!');
        RootNavigation.navigate('Menu');
        return true
      };
      const subscription = BackHandler.addEventListener('hardwareBackPress', onBackPress);
      return () => subscription.remove();
    }, [])
  );


  const uploadImage = async (imageUri, name)=>{
    let formdata = new FormData();
    await formdata.append('file', JSON.stringify({
      // uri: Platform.OS === 'android' ? imageUri : 'file://' + imageUri,
        uri: imageUri,
        name: name,
        type: 'image/jpg' // or your mime type what you want
    }));
    await formdata.append('request', data.id)
    await formdata.append('status', name)
console.log(imageUri);

      console.log('ASHKBOOS', JSON.stringify(formdata.get('file')))


    const response = await trackerApi.post('/webboardPicker', formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    /* transformRequest: (data, headers) => {
    return formdata; // this is doing the trick
},*/})
    // console.log(response.data);
    if(response.status == 500){
      return showMessage({
        message: response.data,
        type: "warning",
      });
    }
    showMessage({
      message: 'با موفقیت بارگذاری شد',
      type: "success",
    });
    // readData();

  }

  // const uploadSign = async (imageUri, name)=>{
  //   let formdata = new FormData();
  //   await formdata.append('file',{
  //       uri: Platform.OS === 'android' ? imageUri : 'file://' + imageUri,
  //       name: name,
  //       type: 'image/png' // or your mime type what you want
  //   });
  //   await formdata.append('request', data.id)
  //   await formdata.append('status', name)
  //
  //
  //   const response = await trackerApi.post('/boardPicker', formdata, {   headers: { "Content-Type": "multipart/form-data" }})
  //   // console.log(response.data);
  //   if(response.status == 500){
  //     return showMessage({
  //       message: response.data,
  //       type: "warning",
  //     });
  //   }
  //   showMessage({
  //     message: 'با موفقیت بارگذاری شد',
  //     type: "success",
  //   });
  //   // readData();
  // }
  const takeImage = async (params) => {
        let result = await ImagePicker.launchCameraAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images,
          allowsEditing: true,
          aspect: [1, 1],
          quality: 0.1,
        });

        console.log('aaab',result);

        if (!result.cancelled) {
          if(params=='new') {
          setNewUri(result.assets[0].uri);
          uploadImage(result.assets[0].uri, 'new')
        }
          else {
            setOldUri(result.assets[0].uri)
            uploadImage(result.assets[0].uri, 'old')
          }
        }
      };
      const pickImage = async (params) => {
            let result = await ImagePicker.launchImageLibraryAsync({
              mediaTypes: ImagePicker.MediaTypeOptions.Images,
              allowsEditing: true,
              aspect: [1, 1],
              quality: 0.1,
              base64: true
            });

            console.log(result);

            if (!result.cancelled) {
              if(params=='new') {
              setNewUri(result.assets[0].uri);
              uploadImage(result.assets[0].uri, 'new')
            }
              else {
                setOldUri(result.assets[0].uri)
                uploadImage(result.assets[0].uri, 'old')
              }
            }
          };
  const saveButton = async ()=>{
    setBtnDisable(true)
    const token =  await AsyncStorage.getItem('userId');
    console.log(registerInvoice);
    const response = await trackerApi.post('/invoice/complete',{
      warranty: registerInvoice.warranty,
      receptor_name: name,
      receptor_phone: phone,
      request_id: data.id,
      invoice_id: registerInvoice.id,
      totalPrice,
      // signUri: signUri.split(',')[1],
      discount: registerInvoice.warranty ? totalPrice : 0,
      pay: registerInvoice.warranty ? 0 : totalPrice,
      payment: payment==1 ? 'نقدی' : payment==2 ? 'کارتخوان' : 'کارت به کارت',
      customerSMS: customerChecked,
      receiverSMS: receiverChecked,
      customerPhone: data.merchant_phone
    } ,
    {
      headers: {Authorization: `Bearer ${token}`}
    });
    setModal(false)
    if(response.data.status) {
      showMessage({
          message: `کار تکمیل شد`,
          type: "success",
        });
      RootNavigation.navigate('Menu')
    }
    else showMessage({
        message: `خطای دیتابیس`,
        type: "danger",
      });
      setBtnDisable(false)
  }

  const toggleSignatue = () => {
    setSignatureModal(!signatureModal)
  }
  return (
      <Layout level='3' style={styles.container}>
        <SafeAreaView>
        <ScrollView>

            <View style={{justifyContent:'space-between', alignItems:'center'}}>
              <CustomerInfo />
            </View>
            <View style={{flexDirection:'row', justifyContent:'space-between', marginTop:15}}>
              <Layout level='2' style={{alignItems:'center',marginHorizontal:10,flex:2, borderRadius:10,  borderColor:'#134A93', borderWidth:1}}>
                <Text category='h5' status='primary'> {moment().locale('fa').format('YYYY/MM/DD')}</Text>
              </Layout>
              <Layout level='2' style={{flexDirection:'row', alignItems:'center',paddingHorizontal:5,marginHorizontal:10,flex:3, borderRadius:10,  borderColor:'#134A93', borderWidth:1}}>
                <Text category='c1'>قابل پرداخت: </Text>
                <Text category='h5' status='primary'>{registerInvoice.warranty? 0 :totalPrice.toLocaleString()}</Text>
                <Text category='c1' status='primary'> ریال</Text>

              </Layout>
            </View>
            <CheckBox
              style={{ marginHorizontal:15, marginTop:10}}
              checked={registerInvoice.warranty ? true : false}
              disabled>

              <Text>
                 خدمات شامل گارانتی می‌باشد.
              </Text>

            </CheckBox>
            <CheckBox
              style={{ marginHorizontal:15, marginTop:10}}
              checked={registerInvoice.sherkati ? true : false}
              disabled>

              <Text>
                  کار غیر شرکتی
              </Text>

            </CheckBox>
            { registerInvoice.sherkati == '1' &&
              <Text appearance='hint' style={{ marginHorizontal:15, marginTop:1}}>توضیحات کار غیرشرکتی: {registerInvoice.sherkati_desc}</Text>
            }
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>موارد انجام شده</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'flex-start', borderColor:'#134A93', borderWidth:1}}>
              {
                costs.length>0 ? costs.map((data, index)=>{
                  const renderToggleButton = (): React.ReactElement => (
                    <TouchableOpacity key={index} onPress={() => setVisible(index+1)} style={{width: width-40, flexDirection:'row', justifyContent:'space-between'}}>
                    <CheckBox
                      style={{ marginHorizontal:15, marginBottom:10}}
                      checked={true}
                       onChange={() => setVisible(index+1)}
                      >
                      <Text category='c2' style={{maxWidth: width-50}}>
                         {data.service_name}
                      </Text>
                      </CheckBox>

                    {/*  <Text category='c2' style={{width: width*0.2}}>
                      { (Number(data.service_cost) * Number(data.qty)).toLocaleString()} ریال
                      </Text>*/}
                      {/*  <Text  style={{width: width*0.1}}>
                           {`${data.qty} x   `}
                        </Text>*/}

                    </TouchableOpacity>
                  );
                  return(
                      <Tooltip
                      anchor={renderToggleButton}
                      visible={(visible-index == 1 ? true : false)}
                      placement='top'
                      onBackdropPress={() => setVisible(0)}
                    >
                    {`${data.service_name} \n`}

                        قیمت واحد: { (Number(data.service_cost) * Number(data.qty)).toLocaleString()} ریال
                        {`    تعداد:  ${data.qty}`}

                    </Tooltip>

                  )

                }) : null
              }


            </Layout>
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>توضیحات</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'flex-start', borderColor:'#134A93', borderWidth:1}}>
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>{registerInvoice.description ? registerInvoice.description : 'توضیحات ثبت نشده است.'}</Text>
            </Layout>
            {/*
            <Text style={{marginTop:10, marginHorizontal:15}} category='p1'>مواردی که شامل خدمات شرکت نمی‌باشد</Text>
            <Text style={{marginHorizontal:15, marginBottom:5}} category='c1' appearance='hint'>هزینه خدمات این بخش به صورت توافقی می‌باشد.</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'flex-start', borderColor:'#134A93', borderWidth:1}}>

            <View style={{marginVertical:5}}>
            <CheckBox
              style={{ marginHorizontal:15}}
              checked={checked1}
              onChange={nextChecked => setChecked1(nextChecked)}>
              <Text>
                سیم کشی غیر اصولی
              </Text>
            </CheckBox>
            { checked1 &&
            <View style={{alignItems:'flex-end', width}}>

            <Input
              placeholder ='هزینه توافق شده خدمات'
              value={cost1}
              label='هزینه (ریال)'
              onChangeText = {newValue =>{ setCost1(newValue)}}
              style={{margin:10,width:0.6*width}}
              keyboardType = 'numeric'
              />
              </View>

            }
            </View>


            <View style={{marginVertical:5}}>
            <CheckBox
              style={{ marginHorizontal:15}}
              checked={checked2}
              onChange={nextChecked => setChecked2(nextChecked)}>
              <Text>حمل و نقل</Text>
            </CheckBox>
            { checked2 &&
            <View style={{alignItems:'flex-end', width}}>

            <Input
              placeholder ='هزینه توافق شده خدمات'
              value={cost1}
              label='هزینه (ریال)'
              onChangeText = {newValue =>{ setCost1(newValue)}}
              style={{margin:10, width:0.6*width}}
              keyboardType = 'numeric'
              />
              </View>

            }
            </View>


            <View style={{marginVertical:5}}>
            <CheckBox
              style={{ marginHorizontal:15}}
              checked={checked3}
              onChange={nextChecked => setChecked3(nextChecked)}>
              <Text>سایر</Text>
            </CheckBox>
            { checked3 &&
            <View style={{alignItems:'flex-end', width}}>

            <Input
              placeholder ='هزینه توافق شده خدمات'
              value={cost1}
              label='هزینه (ریال)'
              onChangeText = {newValue =>{ setCost1(newValue)}}
              style={{margin:10,width:0.6*width}}
              keyboardType = 'numeric'
              />
              </View>
            }
            </View>

            {
              noWarranty.map((data, index)=>{
                return(
                  <View style={{marginVertical:5}} key={index}>
                  <View style={{width: width*0.85, flexDirection:'row', justifyContent:'space-between'}}>
                  <CheckBox
                    style={{ marginHorizontal:15}}
                    checked={true}
                    onChange={()=>{
                      const newArr =  noWarranty;
                      newArr.splice(index,1);
                      console.log(newArr);
                      setNoWarranty(newArr);
                      setChecked10(!checked10)
                    }}>
                    <Input
                      placeholder =' سیم کشی غیر اصولی'
                      value={name}
                      size='small'
                      onChangeText = {newValue =>{ setName(newValue)}}
                      style={{flex:1,margin:10}}
                      />
                  </CheckBox>
                  <TouchableOpacity onPress={()=>{
                    const newArr =  noWarranty;
                    newArr.splice(index,1);
                    console.log(newArr);
                    setNoWarranty(newArr);
                    setChecked10(!checked10)
                  }}>
                  <Text status='danger' category='c1'>حذف</Text>
                  </TouchableOpacity>
                  </View>
                  <View style={{alignItems:'flex-end', width}}>
                  <Input

                    placeholder ='هزینه توافق شده خدمات'
                    value={cost1}
                    label='هزینه (ریال)'
                    onChangeText = {newValue =>{ setCost1(newValue)}}
                    style={{margin:10, width:0.6*width}}
                    keyboardType = 'numeric'

                    />
                    </View>
                  </View>
                )
              })
            }



            <View style={{justifyContent:'flex-end', alignItems:'flex-end', width, paddingHorizontal:15}}>
            <Button size='small' appearance='ghost' accessoryLeft={PlusIcon} onPress={()=>{setNoWarranty([...noWarranty,'test'])}}>افزودن</Button>
            </View>
            </Layout>
*/}
            { data.service_type ==='تعمیر' &&
            <View>
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>تصویر بورد قدیمی</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1}}>
            <View style={{flexDirection: 'row', justifyContent:'space-between'}}>
            <Button size='small' appearance='ghost' accessoryLeft={CameraIcon} onPress={()=> takeImage('old')} >{oldUri? 'دوربین' : 'دوربین'}</Button>
            <Button size='small' appearance='ghost' accessoryLeft={GalleryIcon} onPress={()=> pickImage('old')} >{oldUri? 'گالری' : 'گالری'}</Button>
            </View>
            {(oldUri || (registerInvoice&&registerInvoice.oldimage_uri)) &&
            <Image
              style={{width:width*0.8, height: width*0.8/1.43, marginVertical:10}}
              source={{uri: !oldUri ? `https://api.fntpf.ir/assets/uploaded/boards/${registerInvoice.oldimage_uri}` : oldUri}} />}
            </Layout>

            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>تصویر بورد جدید</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1}}>
            <View style={{flexDirection: 'row', justifyContent:'space-between'}}>
            <Button size='small' appearance='ghost' accessoryLeft={CameraIcon} onPress={()=> takeImage('new')} >{newUri? 'دوربین' : 'دوربین'}</Button>
            <Button size='small' appearance='ghost' accessoryLeft={GalleryIcon} onPress={()=> pickImage('new')} >{newUri? 'گالری' : 'گالری'}</Button>
            </View>            {(newUri || (registerInvoice&&registerInvoice.newimage_uri))&&
            <Image
              style={{width:width*0.8, height: width*0.8/1.43, marginVertical:10}}
              source={{uri: !newUri ? `https://api.fntpf.ir/assets/uploaded/boards/${registerInvoice.newimage_uri}` : newUri}} />}
            </Layout>
            </View>
          }


            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>اطلاعات تحویل گیرنده</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1, width}}>
            <Input
              placeholder ='نام تحویل گیرنده'
              value={name}
              label='نام تحویل گیرنده'
              onChangeText = {newValue =>{ setName(newValue)}}
              style={{margin:10, width: width-30}}
              />
              <Input
                placeholder ='شماره تماس'
                value={phone}
                label='شماره تماس تحویل گیرنده'
                onChangeText = {newValue =>{ setPhone(newValue)}}
                style={{margin:10, width: width-30}}
                keyboardType='numeric'
                maxLength={11}
                />
            {/*  <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>امضای مشتری</Text>
              <TouchableOpacity onPress= {toggleSignatue}>
              <Layout level='2' style={{width: width*0.80, height: width*0.90, borderRadius:10}}>
              <Image style={{flex:1}} source={{uri: signUri}}/>

              </Layout>
              </TouchableOpacity>
              */}
            </Layout>
            <View style={{flexDirection:'row', justifyContent:'space-between',paddingHorizontal:15}}>
            <Button appearance='outline' style={{flex:1,marginHorizontal:6, marginVertical:15, borderRadius:10}} onPress={()=>{RootNavigation.navigate('Menu')}}>بازگشت</Button>

            <Button status='success' accessoryLeft={LinkIcon} style={{flex:3,marginHorizontal:6, marginVertical:15, borderRadius:10}} onPress={()=>{
              if((!(oldUri || registerInvoice.oldimage_uri))&& (data.service_type ==='تعمیر')) showMessage({
                  message: `لطفا تصویر بورد قدیمی را بارگذاری نمایید.`,
                  type: "warning",
                });
              else if((!(newUri || registerInvoice.newimage_uri)) && (data.service_type ==='تعمیر')) showMessage({
                  message: `لطفا تصویر بورد جدید را بارگذاری نمایید.`,
                  type: "warning",
                });
              else if(name.length < 2) showMessage({
                  message: `لطفا نام مشتری را به درستی وارد نمایید.`,
                  type: "warning",
                });
              else if(phone.length < 8) showMessage({
                  message: `لطفا شماره مشتری را به درستی وارد نمایید.`,
                  type: "warning",
                });
              // else if(!signUri) showMessage({
              //     message: `لطفا امضای مشتری را بگیرید.`,
              //     type: "warning",
              //   });
              else setModal(true)
            }}>تسویه حساب</Button>
            </View>
          </ScrollView>
          <Modal
             visible={modal}
             backdropStyle={styles.backdrop}
             onBackdropPress={() => setModal(false)}>
             <Card disabled={false}>

             <Text category='h6' status='primary' style={{marginBottom:10}}>روش پرداخت</Text>

             <View style={{flexDirection:'row', justifyContent:'flex-end', marginVertical:15}}>
             <Button appearance='outline' status={payment==1 ? 'primary' : 'basic'} style={{marginHorizontal:5}} onPress={()=>{setPayment(1)}}>
               نقدی
             </Button>
             <Button appearance='outline' status={payment==2 ? 'primary' : 'basic'} style={{marginHorizontal:5}} onPress={()=>{setPayment(2)}}>
               کارتخوان
             </Button>
             <Button appearance='outline' status={payment==3 ? 'primary' : 'basic'} style={{marginHorizontal:5}} onPress={()=>{setPayment(3)}}>
               کارت به کارت
             </Button>
             </View>
             <Text category='h5' status='primary' style={{marginBottom:25, textAlign:'center'}}> قابل پرداخت: {registerInvoice.warranty? 0 :totalPrice.toLocaleString()} ریال</Text>
             <View style={{justifyContent:'flex-end'}}>
             <CheckBox
               style={{ marginHorizontal:15, marginTop:10}}
               checked={customerChecked}
               onChange={nextChecked => setCustomerChecked(nextChecked)}>


               <Text>
                ارسال فاکتور برای مشتری
               </Text>

             </CheckBox>
             <CheckBox
               style={{ marginHorizontal:15, marginTop:10, marginBottom: 25}}
               checked={receiverChecked}
               onChange={nextChecked => setReceiverChecked(nextChecked)}>


               <Text>
                  ارسال فاکتور برای تحویل گیرنده
               </Text>

             </CheckBox>
             </View>
             <View style={{flexDirection:'row', justifyContent:'flex-end'}}>
               <Button appearance='ghost' style={{marginHorizontal:5}} onPress={()=>{setModal(false)}}>
                 انصراف
               </Button>
               <Button disabled={btnDisable} style={{marginHorizontal:5}} onPress={()=>{saveButton()}}>
                  بایگانی
                </Button>
                </View>
             </Card>
           </Modal>
           <Modal
              visible={signatureModal}
              style={{width:width+20}}
              backdropStyle={styles.backdrop}
              onBackdropPress={toggleSignatue}>
              <Card disabled={false} style={{padding:10}}>
              <Text style={{marginBottom:10}} category='h6' status='primary'>امضای مشتری</Text>
              <Layout level='2' style={{marginBottom:15, height: width*0.9, borderRadius:10}}>
              <Sign text='تست' onOK={setSignUri} toggle={toggleSignatue}/>

              </Layout>

              </Card>
            </Modal>
        </SafeAreaView>
      </Layout>
  );
};

const styles = StyleSheet.create({
    container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
